module.exports = __webpack_public_path__ + "img/advantage5@2x.b24f084c.png";